import React from 'react'
import AdmFeeSearch from '../../components/AdminTabs/AdminFeeSearch/AdmFeeSearch'

const FeeSearch = () => {
  return (
    <div>
      <AdmFeeSearch />
    </div>
  )
}

export default FeeSearch
